import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './mutation.action';

@Injectable({ providedIn: 'root' })
export class MutationTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                created_at: '',
                handled_at: null,
                member_id: '',
                member_name: ''
            };


    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    clubId = 0;
    countries = [];
    genders = [
        {"id": "1", "name": "MEMBER.male"},
        {"id": "2", "name": "MEMBER.female"},
        {"id": "3", "name": "MEMBER.unspecified"},
    ];
    adjusteds = [
        {"id": "0", "name": "COMMON.no"},
        {"id": "1", "name": "COMMON.yes"},
    ];
    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date", widthSet: 155},
                { prop: 'member_id', name: 'MUTATION.member-id', sortable: true, hasFilter: true, filter: "input", widthSet: 90},
                { prop: 'member_name', name: 'MUTATION.member-name', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'field_translation', name: 'MUTATION.field', sortable: false, hasFilter: false, filter: "input"},
                { prop: 'previous_value', name: 'MUTATION.previous-value', sortable: false, hasFilter: false, filter: "input"},
                { prop: 'new_value', name: 'MUTATION.new-value', sortable: false, hasFilter: false, filter: "input"},
                { prop: 'handled_at', name: 'MUTATION.adjusted', sortable: true, hasFilter: true, filter: "select", options: 'adjusteds', options_id: "id", options_label: "name" , widthSet: 165},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            // (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            Object.entries(this.filters).some(([key, value]) => {
                if (key === 'mutation_status'){
                    return value !== '1';
                }

                return value !== '' && value !== null;
            }) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;

    }

    resetState(){
        this.filters = {
            created_at: '',
            handled_at: null,
            member_id: '',
            member_name: ''
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;
    }

    resetFilters(){
        this.resetState();
        this.loadRecords();
    }

}